import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';

import {fetchCompaniesDispatch} from '../actions';

import SearchMembers from './search-members';
import FilterTypes from './filter-types';
import CompanyList from './company-list';

class MemberList extends Component {
	componentWillMount() {
		this.props.fetchCompaniesDispatch();
	}

	render() {
		return (<Fragment>
			<FilterTypes />
			<SearchMembers />
			<CompanyList />
		</Fragment>);
	}
}

export default connect(null, {fetchCompaniesDispatch})(MemberList);